import axios from 'axios';
import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import createMetadataAPIActions from '../../utils/api-metadata-actions';
import { constructURL } from '../../utils/api-metadata-utils';

const options = {
  name: 'payrollPositions',
  baseType: 'PAYROLL_POSITIONS',
  apiEndpoint: 'memberships/{membership_id}/payroll_positions'
};

const REPLACE_MEMBERSHIP_POSITIONS = 'REPLACE_MEMBERSHIP_POSITIONS';

const actions = createMetadataAPIActions(options);
actions.replaceMembershipPositions = (membershipId, positions) => ({
  type: REPLACE_MEMBERSHIP_POSITIONS,
  payload: { membershipId, positions }
});

const operations = createMetadataAPIOperations(options);
const selectors = createMetadataAPISelectors(options);

operations.storeMembershipPositions = (membershipId, positions) => dispatch => {
  dispatch(actions.replaceMembershipPositions(membershipId, positions));

  const url = constructURL(options.apiEndpoint, [], {
    membership_id: membershipId
  });

  // remove all old ones from redux set to the new ones received
  // bulk create
  return axios.post(url, { positions }).then(response => {
    dispatch(actions.createInBackendSuccessful(response.data));
  });
};

export { operations, selectors, actions };

const reducer = createMetadataAPIReducer(options);

const augmentedReducer = (state, action) => {
  let result = reducer(state, action);

  switch (action.type) {
    // Removes all positions for a membership, and replaces it with the given
    // ones
    case REPLACE_MEMBERSHIP_POSITIONS: {
      const { membershipId, positions } = action.payload;

      // filter out all existing positions for this membership
      const oldById = state.byId;
      const filtered = Object.keys(state.byId)
        .filter(key => oldById[key].membership_id !== membershipId)
        .reduce((res, key) => ((res[key] = oldById[key]), res), {});

      // add the new positions
      const newById = positions.reduce((res, position) => ({ ...res, [position.id]: position }), filtered);

      return { ...state, byId: newById };
    }
    default: {
      return result;
    }
  }
};

export default augmentedReducer;
